import { Container, Grid, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '5%',
    fontFamily: 'OpenSans',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
  },
  titulo: {
    width: '78px',
    height: '16px',
    margin: '0 129px 4px 0',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#2e62b8',
  },
  subTitulo: {
    width: '207px',
    height: '27px',
    margin: '4px 0 20px',
    fontSize: '20px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  content: {
    width: '198px',
    margin: '24px 9px 375px 0',
    fontSize: '16px',
    color: '#464646',
  },
  image: {
    position: 'fixed',
    bottom: '9%',
  },
  logoFatureMais: {
    position: 'fixed',
    bottom: '3%',
    width: '200px',
    height: '69px',
  },
  logoGroupFinanceiro: {
    position: 'fixed',
    bottom: '2.5%',
    width: '164px',
    height: '60px',
    marginLeft: '2%',
  },
}));

const Titulo = ({ children }) => {
  const classes = useStyles(useStyles);
  return <div className={classes.titulo}>{children}</div>;
};

const SubTitulo = ({ children }) => {
  const classes = useStyles(useStyles);
  return <div className={classes.subTitulo}>{children}</div>;
};

const Conteudo = ({ children }) => {
  const classes = useStyles(useStyles);
  return <label className={classes.content}>{children}</label>;
};

const InformativoLateral = ({ titulo, subTitulo, children, imagem }) => {
  const classes = useStyles(useStyles);

  return (
    <Container>
      <Grid item className={classes.root}>
        <Grid item>
          <Titulo>{titulo}</Titulo>
        </Grid>
        <Grid item>
          <SubTitulo>{subTitulo}</SubTitulo>
        </Grid>
        <Grid item>
          <Conteudo>{children}</Conteudo>
        </Grid>
        <Grid item className={classes.image}>
          <img height={'80%'} width={'80%'} src={imagem} alt="onboarding" />
        </Grid>
        <Grid item className={classes.logo}>
          {process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? (
            <Grid item className={classes.logoFatureMais}>
              <img src="assets/images/logos/fature_mais_azul.svg" alt="logo" />
            </Grid>
          ) : (
            <Grid item className={classes.logoGroupFinanceiro}>
              <img src="assets/images/logos/group_financeiro_azul.png" alt="logo" />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default InformativoLateral;
